import React from "react";
import "./WorkExperience.scss";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import {workExperiences} from "../../portfolio";
import {Fade} from "react-reveal";

export default function WorkExperience() {
  if (workExperiences.display) {
    return (
      <div id="experience">
        <Fade bottom duration={1000} distance="20px">
          <div className="experience-container" id="workExperience">
            <div>
              <div className="experience-story-header">
                <span className="resume-bg-word" aria-hidden="true">
                  MY RESUME
                </span>
                <span className="resume-slashes" aria-hidden="true">
                  {"//"}
                </span>
                <span className="resume-kicker">About Me</span>
                <h1 className="experience-heading">
                  My Awesome <span>Story</span>
                </h1>
                <p className="subTitle experience-intro">
                  This is my history as a builder, an experience of learning,
                  upskilling, creating practical work and building relationships
                  along the way. My education sits here briefly too: I am
                  studying Data Science and Informatics at Midlands State
                  University.
                </p>
              </div>
              <div className="experience-cards-div">
                {workExperiences.experience.map((card, i) => {
                  return (
                    <ExperienceCard
                      key={i}
                      index={i}
                      cardInfo={{
                        company: card.company,
                        desc: card.desc,
                        date: card.date,
                        companylogo: card.companylogo,
                        role: card.role,
                        descBullets: card.descBullets
                      }}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </Fade>
      </div>
    );
  }
  return null;
}
